
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";
import { Product } from "@/lib/types";
import { Plus, Minus } from "lucide-react";

interface ProductCardFooterProps {
  product: Product;
  onAddStock: () => void;
  onRecordUsage: () => void;
  onQuickUsage: () => void;
  children?: React.ReactNode;
}

const ProductCardFooter = ({ 
  product, 
  onAddStock, 
  onRecordUsage, 
  onQuickUsage,
  children
}: ProductCardFooterProps) => {
  return (
    <CardFooter className="flex flex-col space-y-2">
      <div className="flex gap-2 w-full">
        <Button 
          variant="outline" 
          size="sm" 
          className="flex-1" 
          onClick={onAddStock}
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Stock
        </Button>
        <Button 
          variant="outline" 
          size="sm" 
          className="flex-1" 
          onClick={onRecordUsage}
        >
          <Minus className="h-4 w-4 mr-2" />
          Use
        </Button>
      </div>
      <div className="w-full flex gap-2">
        <Button 
          size="sm" 
          className="w-full"
          onClick={onQuickUsage}
        >
          <Minus className="h-4 w-4 mr-2" />
          Quick Use (1)
        </Button>
      </div>
      {children}
    </CardFooter>
  );
};

export default ProductCardFooter;
